module.exports = __webpack_public_path__ + "static/media/Metasploit.fc0cf391.svg";